import { FeatureFlagsConfig, CurrentSiteFeatures, SiteAccessibility, SiteData, UserInformation } from '../../types';

const API_PATH = '/api' as const;

export const TENANT_PATH = `${API_PATH}/auth/user/Tenant` as const;

export const CURRENT_SITE_DATA_PATH = `${API_PATH}/platform/currentSite` as const;

export const ALL_SITE_CONFIGS_PATH = `${API_PATH}/platform/configs` as const;

export const USER_INFO_PATH = `${API_PATH}/platform/userinfo` as const;

export const FEATURE_FLAGS_CONFIG_PATH = `${API_PATH}/platform/flags/config` as const;

export const CURRENT_SITE_FEATURES_PATH = `${API_PATH}/platform/currentSiteFeatures` as const;

export class APIService {
  public async setPreferredTenant(tenantId: string): Promise<string> {
    const headers: Headers = new Headers();
    headers.set('Content-Type', 'application/json');

    const body = JSON.stringify({
      activeTenant: tenantId,
    });

    const response = await fetch(TENANT_PATH, { method: 'POST', headers, body });
    const data = await response.json();

    return data;
  }

  public async getSiteData(): Promise<SiteData> {
    const response = await fetch(CURRENT_SITE_DATA_PATH);
    const data: SiteData = await response.json();

    return {
      ...data,
      legacy_slug: removeSpaces(data.name).toLowerCase(),
    };
  }

  public async getUserSiteConfigs(): Promise<SiteAccessibility[]> {
    const response = await fetch(ALL_SITE_CONFIGS_PATH);
    // This service degrades to [] rather than failing — mirroring the API itself,
    // which answers 200 + [] when it errors internally.
    if (!response.ok) {
      return [];
    }
    const data = (await response.json()) as SiteAccessibility[];
    return data
      .filter((s) => s.site_id !== '')
      .sort((a, b) => {
        if (a.residency.toUpperCase() === 'GLOBAL') {
          return -1;
        }
        if (b.residency.toUpperCase() === 'GLOBAL') {
          return 1;
        }
        return a.name.localeCompare(b.name);
      });
  }

  public async getUserInfo(): Promise<UserInformation> {
    const response = await fetch(USER_INFO_PATH);
    return await response.json();
  }

  public async getFeatureFlagsConfig(): Promise<FeatureFlagsConfig> {
    const response = await fetch(FEATURE_FLAGS_CONFIG_PATH);
    return await response.json();
  }

  public async getCurrentSiteFeatures(): Promise<CurrentSiteFeatures> {
    const response = await fetch(CURRENT_SITE_FEATURES_PATH);
    return await response.json();
  }
}

function removeSpaces(str: string | undefined): string {
  if (str) {
    return str.replace(/\s/g, '');
  }
  return '';
}
